<template>
	<div
		@click="disabled ? null : click_handler()"
		class="flex w-full items-center justify-between bg-white group transition-all duration-300 ease-out"
		:class="{
			'rounded-5xl px-[15px] py-[10px] border border-neutral-200 hover:scale-[1.01] hover:shadow-sm': !dark_button,
			'my-0': no_margin,
			'mb-0': !no_margin,
			'cursor-pointer active:scale-[0.98]': !disabled,
			'opacity-90': disabled,
		}"
	>
		<div class="flex flex-row items-center">
			<img
				v-if="icon"
				:src="icon"
				:alt="title + ' icon'"
				class="z-1 w-5 mr-[7px] transition-transform duration-200 group-hover:scale-110"
			/>

			<p
				v-html="title"
				class="text-sm font-bold transition-colors duration-200"
				:class="{
					'text-black group-hover:text-black': dark_button,
					'opacity-50': disabled,
				}"
			></p>
		</div>

		<img
			:src="
				dark_button
					? '/images/icons/icon-arrow-rg-blue.png'
					: '/images/icons/blue-arrow-icon.svg'
			"
			alt="arrow icon"
			class="z-1 w-5 transition-transform duration-200"
			:class="{
				'opacity-50': disabled,
			}"
			:style="disabled ? { filter: 'brightness(0) saturate(100%)' } : {}"
		/>
	</div>
</template>

<script lang="js" src="./ArrowButton.js"></script>